<template>
  <div id="app">
    <a-layout>
      <a-layout-content>
        <router-view />
      </a-layout-content>
      <a-layout-footer>
        <Footer />
      </a-layout-footer>
    </a-layout>
  </div>
</template>

<script>
import { Layout } from "ant-design-vue";
import Footer from '@/components/Footer'

export default {
  name: "App",
  components: {
    Footer,
    ALayout: Layout,
    ALayoutContent: Layout.Content,
    ALayoutFooter: Layout.Footer,
  },
};
</script>

<style scoped>
.ant-layout .ant-layout-footer {
  height: 290px;
  padding:0;
}
</style>
